import React from "react";
import { Landmark, LineChart, Layers, KeyRound } from "lucide-react";
import PillarPage from "../components/PillarPage";

const content = {
  kicker: "Property Portfolios",
  title: "A long-term holder of residential portfolios.",
  subtitle:
    "OTP Group acquires residential property portfolios from landlords and vendors seeking a clean, certain sale, and holds them for the long term under professional management.",

  criteriaKicker: "What we look for",
  criteriaTitle: "Portfolios we acquire.",
  criteriaIntro:
    "We acquire portfolios to hold, not to trade. We are most interested in residential stock where a straightforward transaction suits the vendor.",
  criteria: [
    "Residential portfolios of multiple units, whole or in part.",
    "Tenanted or vacant stock in established residential areas.",
    "Single-region or multi-region portfolios.",
    "Properties with or without existing management in place.",
    "Vendors seeking certainty and a clean exit.",
  ],

  whyKicker: "Why sell to us",
  whyTitle: "Certainty and a clean transaction.",
  whyBlocks: [
    {
      icon: Landmark,
      title: "A committed buyer",
      text: "We buy to hold for the long term, so you are dealing with a genuine end purchaser rather than an intermediary.",
    },
    {
      icon: KeyRound,
      title: "Care for tenants",
      text: "Existing tenants experience continuity, with professional management in place from day one.",
    },
    {
      icon: LineChart,
      title: "Funding certainty",
      text: "Our acquisitions are funded through arranged debt, allowing us to proceed with confidence and pace.",
    },
    {
      icon: Layers,
      title: "Flexible structures",
      text: "We can accommodate whole-portfolio or phased transactions and structure terms to suit the sale.",
    },
  ],

  processKicker: "Our process",
  processTitle: "From enquiry to completion.",
  steps: [
    { title: "Confidential conversation", text: "An initial discussion to understand the portfolio and your objectives." },
    { title: "Appraisal & indicative terms", text: "We appraise the portfolio and set out an indicative offer." },
    { title: "Due diligence", text: "A proportionate review of titles, tenancies and condition." },
    { title: "Completion & onboarding", text: "We complete and onboard the properties into professional management." },
  ],

  proofKicker: "Track record",
  proofTitle: "A stewardship approach.",
  proofIntro:
    "We take a stewardship approach to every portfolio we acquire, managing for the long term rather than for a quick resale.",
  proofItems: [
    { name: "Long-term hold", text: "Portfolios are acquired to hold and manage, not to flip." },
    { name: "UK-wide", text: "We consider residential portfolios across the United Kingdom." },
  ],

  ctaTitle: "Selling a portfolio?",
  ctaText:
    "If you are considering selling a residential portfolio, we would welcome a confidential, no-obligation conversation.",
  ctaButtonLabel: "Start a conversation",
  ctaTo: "/contact?path=portfolio-sale",
};

const PropertyPortfolios = () => <PillarPage content={content} />;

export default PropertyPortfolios;
